"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolyjuiceWebsocketProvider = exports.PolyjuiceJsonRpcProvider = void 0;
const ethers_1 = require("ethers");
const bytes_1 = require("@ethersproject/bytes");
const bignumber_1 = require("@ethersproject/bignumber");
const base_1 = require("@polyjuice-provider/base");
class PolyjuiceJsonRpcProvider extends ethers_1.providers.JsonRpcProvider {
    constructor(polyjuice_config, url, network) {
        super(url, network);
        const abi_items = polyjuice_config.abiItems || [];
        this.abi = new base_1.Abi(abi_items);
        const web3_url = typeof url === "string" ? url : url.url;
        const godwoker_option = {
            godwoken: {
                rollup_type_hash: polyjuice_config.rollupTypeHash,
                eth_account_lock: {
                    code_hash: polyjuice_config.ethAccountLockCodeHash,
                    hash_type: "type",
                },
            },
        };
        this.godwoker = new base_1.Godwoker(web3_url, godwoker_option);
    }
    setAbi(abiItems) {
        this.abi = new base_1.Abi(abiItems);
    }
    async sendTransaction(signedTransaction) {
        await this.getNetwork();
        const hexTx = await Promise.resolve(signedTransaction).then((t) => bytes_1.hexlify(t));
        //const tx = this.formatter.transaction(signedTransaction);
        const blockNumber = await this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
        try {
            const hash = await this.perform("sendTransaction", {
                signedTransaction: hexTx,
            });
            // TODO replace with real eth tx deserialize from godwoken signed tx serialized hex string
            const fake_tx = {
                hash: hash,
                from: "0x",
                nonce: 0,
                gasLimit: bignumber_1.BigNumber.from("0x00"),
                gasPrice: bignumber_1.BigNumber.from("0x00"),
                data: "0x00",
                value: bignumber_1.BigNumber.from("0x00"),
                chainId: 3,
            };
            return this._wrapTransaction(fake_tx, hash, blockNumber);
        }
        catch (error) {
            error.transaction = null;
            error.transactionHash = null;
            throw error;
        }
    }
    async send(method, params) {
        await this.godwoker.init();
        switch (method) {
            case "eth_call":
                try {
                    params[0].from =
                        params[0].from ||
                            (await this.godwoker.getPolyjuiceDefaultFromAddress());
                    params[0].gas =
                        params[0].gas ||
                            `0x${BigInt(base_1.POLY_MAX_TRANSACTION_GAS_LIMIT).toString(16)}`;
                    params[0].gasPrice =
                        params[0].gasPrice ||
                            `0x${BigInt(base_1.POLY_MIN_GAS_PRICE).toString(16)}`;
                    params[0].value = params[0].value || "0x00";
                    const t = params[0];
                    return await base_1.executeCallTransaction(this.abi, this.godwoker, t);
                }
                catch (error) {
                    this.emit("debug", {
                        action: "response",
                        error: error,
                        provider: this,
                    });
                    throw error;
                }
            case "eth_estimateGas":
                try {
                    const { data } = params[0];
                    const data_with_short_address = await this.abi.refactor_data_with_short_address(data, this.godwoker.getShortAddressByAllTypeEthAddress.bind(this.godwoker));
                    params[0].data = data_with_short_address;
                    params[0].from =
                        params[0].from ||
                            (await this.godwoker.getPolyjuiceDefaultFromAddress());
                    return super.send(method, params); // todo: this should send and parse by provider
                }
                catch (error) {
                    this.emit("debug", {
                        action: "response",
                        error: error,
                        provider: this,
                    });
                    throw error;
                }
            default:
                return super.send(method, params);
        }
    }
    prepareRequest(method, params) {
        switch (method) {
            case "sendTransaction":
                return ["poly_submitL2Transaction", [params.signedTransaction]];
            default:
                return super.prepareRequest(method, params);
        }
    }
}
exports.PolyjuiceJsonRpcProvider = PolyjuiceJsonRpcProvider;
let NextId = 1;
class PolyjuiceWebsocketProvider extends ethers_1.providers.WebSocketProvider {
    constructor(polyjuiceConfig, url, network) {
        super(url, network);
        const godwoker_option = {
            godwoken: {
                rollup_type_hash: polyjuiceConfig.rollupTypeHash,
                eth_account_lock: {
                    code_hash: polyjuiceConfig.ethAccountLockCodeHash,
                    hash_type: "type",
                },
            },
        };
        if (!polyjuiceConfig.web3Url || !base_1.verifyHttpUrl(polyjuiceConfig.web3Url)) {
            throw new Error("You must provide web3 http-protocol URL in PolyjuiceConfig when using polyjuice websocket provider. this restrict might be removed in the future. but right now, please bear with this method.");
        }
        this.godwoker = new base_1.Godwoker(polyjuiceConfig.web3Url, godwoker_option);
        const abi_items = polyjuiceConfig.abiItems || [];
        this.abi = new base_1.Abi(abi_items);
    }
    setAbi(abiItems) {
        this.abi = new base_1.Abi(abiItems);
    }
    async sendTransaction(signedTransaction) {
        await this.getNetwork();
        const hexTx = await Promise.resolve(signedTransaction).then((t) => bytes_1.hexlify(t));
        //const tx = this.formatter.transaction(signedTransaction);
        const blockNumber = await this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
        try {
            const hash = await this.perform("sendTransaction", {
                signedTransaction: hexTx,
            });
            // TODO replace with real eth tx deserialize from godwoken signed tx serialized hex string
            const fake_tx = {
                hash: hash,
                from: "0x",
                nonce: 0,
                gasLimit: bignumber_1.BigNumber.from("0x00"),
                gasPrice: bignumber_1.BigNumber.from("0x00"),
                data: "0x00",
                value: bignumber_1.BigNumber.from("0x00"),
                chainId: 3,
            };
            return this._wrapTransaction(fake_tx, hash, blockNumber);
        }
        catch (error) {
            error.transaction = null;
            error.transactionHash = null;
            throw error;
        }
    }
    prepareRequest(method, params) {
        switch (method) {
            case "sendTransaction":
                return ["poly_submitL2Transaction", [params.signedTransaction]];
            default:
                return super.prepareRequest(method, params);
        }
    }
    send(method, params) {
        const rid = NextId++;
        return new Promise(async (resolve, reject) => {
            function callback(error, result) {
                if (error) {
                    return reject(error);
                }
                return resolve(result);
            }
            const payload = JSON.stringify({
                method: method,
                params: params,
                id: rid,
                jsonrpc: "2.0",
            });
            this.emit("debug", {
                action: "request",
                request: JSON.parse(payload),
                provider: this,
            });
            this._requests[String(rid)] = { callback, payload };
            if (this._wsReady) {
                await this.godwoker.init();
                switch (method) {
                    case "eth_call":
                        try {
                            params[0].from =
                                params[0].from ||
                                    (await this.godwoker.getPolyjuiceDefaultFromAddress());
                            params[0].gas =
                                params[0].gas ||
                                    `0x${BigInt(base_1.POLY_MAX_TRANSACTION_GAS_LIMIT).toString(16)}`;
                            params[0].gasPrice =
                                params[0].gasPrice ||
                                    `0x${BigInt(base_1.POLY_MIN_GAS_PRICE).toString(16)}`;
                            params[0].value = params[0].value || "0x00";
                            const t = params[0];
                            const return_value = await base_1.executeCallTransaction(this.abi, this.godwoker, t);
                            return callback(null, return_value);
                        }
                        catch (error) {
                            this.emit("debug", {
                                action: "response",
                                error: error,
                                provider: this,
                            });
                            return callback(error, null);
                        }
                    case "eth_estimateGas":
                        try {
                            const { data } = params[0];
                            const data_with_short_address = await this.abi.refactor_data_with_short_address(data, this.godwoker.getShortAddressByAllTypeEthAddress.bind(this.godwoker));
                            params[0].data = data_with_short_address;
                            params[0].from =
                                params[0].from ||
                                    (await this.godwoker.getPolyjuiceDefaultFromAddress());
                            return this._websocket.send(payload); // this should handle and parse by provider
                        }
                        catch (error) {
                            this.emit("debug", {
                                action: "response",
                                error: error,
                                provider: this,
                            });
                            return callback(error, null);
                        }
                    default:
                        return this._websocket.send(payload);
                }
            }
        });
    }
}
exports.PolyjuiceWebsocketProvider = PolyjuiceWebsocketProvider;
exports.default = { PolyjuiceJsonRpcProvider, PolyjuiceWebsocketProvider };
//# sourceMappingURL=providers.js.map